import React from 'react';
import App from './components/App';
import { Provider as ModelProvider } from './data-providers/model';
import { Provider as ReduxProvider } from 'react-redux';
import createStore from '../store/createStore';

const store = createStore();

const appFactory = model => (
  <ModelProvider value={model}>
    <ReduxProvider store={store}>
      <App />
    </ReduxProvider>
  </ModelProvider>
);

export default appFactory;



// WEBPACK FOOTER //
// ./src/client/js/view/app-factory.js